module.exports = __webpack_public_path__ + "img/Emission Certification Label Example.2b3cbd73.jpg";